
import {
    CORE_GET_REPORT_DRAWING_STATUS_REQUEST,
    CORE_GET_REPORT_DRAWING_STATUS_SUCCESS,
    CORE_GET_REPORT_DRAWING_STATUS_FAILURE,

    CORE_GET_REPORT_FOLLOW_STATUS_REQUEST,
    CORE_GET_REPORT_FOLLOW_STATUS_SUCCESS,
    CORE_GET_REPORT_FOLLOW_STATUS_FAILURE,

    CORE_GET_REPORT_SUMMARY_STATUS_REQUEST,
    CORE_GET_REPORT_SUMMARY_STATUS_SUCCESS,
    CORE_GET_REPORT_SUMMARY_STATUS_FAILURE,

    CORE_GET_REPORT_VIEW_DRAWING_REQUEST,
    CORE_GET_REPORT_VIEW_DRAWING_SUCCESS,
    CORE_GET_REPORT_VIEW_DRAWING_FAILURE,

    REQUEST_STATE
} from '../types'
const requestState = REQUEST_STATE

export default {
    report: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_REPORT_DRAWING_STATUS_REQUEST:
                return state
            case CORE_GET_REPORT_DRAWING_STATUS_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    }
                    return {}
                } else return {}
            case CORE_GET_REPORT_DRAWING_STATUS_FAILURE:
                return {}
            default:
                return state
        }
    },
    reportFollow: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_REPORT_FOLLOW_STATUS_REQUEST:
                return state
            case CORE_GET_REPORT_FOLLOW_STATUS_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    }
                    return []
                } else return []
            case CORE_GET_REPORT_FOLLOW_STATUS_FAILURE:
                return []
            default:
                return state
        }
    },
    reportSummary: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_REPORT_SUMMARY_STATUS_REQUEST:
                return state
            case CORE_GET_REPORT_SUMMARY_STATUS_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    }
                    return []
                } else return []
            case CORE_GET_REPORT_SUMMARY_STATUS_FAILURE:
                return []
            default:
                return state
        }
    },

    reportViewDrawing: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_REPORT_VIEW_DRAWING_REQUEST:
                return state
            case CORE_GET_REPORT_VIEW_DRAWING_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && Array.isArray(datas)) {
                        return action.payload
                    }
                    return { datas: [] }
                } else return { datas: [] }
            case CORE_GET_REPORT_VIEW_DRAWING_FAILURE:
                return { datas: [] }
            default:
                return state
        }
    },

}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/report.js